
import api from './api'

export default {

    list() {

        return api.get('/habilitations', {})
            .then( json => json.data )
            
    }
}
